<template>
    <el-dialog
            :visible.sync="dialogVisible"
            width="480px"
            v-model="dialogData"
            class="dialogClass"
            :showClose=dialogData.showClo
            :close-on-click-modal="false"
            >
    <div slot="title" style="margin:0px;padding:0px;height:20px;">
        <b>{{$t('report_system_prompt')}}</b>
        <el-divider ></el-divider>
    </div>

    <el-row>
        <el-col :span="2" style="padding-top:10px">
            <span    :class="dialogData.icon" style="padding:12px 0 ;font-size: 32px;width:10px;"></span>
        </el-col>
        <el-col :span="22" style="padding:15px;">
          <span style="float:left;font-size:14px;">
            {{dialogData.text}}
          </span>
            <span style="left:0px;margin:20px;float:left;font-size:11px;">
            {{dialogData.info}}
          </span>
        </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
        <el-button style="margin-left:7%"
                   type="primary"
                   plain
                   @click="dialogVisible = false;"
        >确认</el-button>
      </span>
    </el-dialog>

</template>
<script>
    import { mapGetters } from "vuex";

    export default {
        name: "reportdialog",


        data(){

            return {
                dialogVisible:false,
                dialogData:{icon:'iconfontcolor icon-info',showClo:true,title:"",text:"",info:"",buttom:{}},
                dialogIcon:{error:"icon-color-error  iconfontcolor",info:"iconfontcolor icon-info"}
            };
        },
        watch: {

        },

        mounted() {

        },
        methods: {

            showDialog(item) {
              if (item.hasOwnProperty("title")) this.dialogData.title=item.title;
              this.dialogData.text =item.hasOwnProperty("text")?item.text:"";
              this.dialogData.info=item.hasOwnProperty("info")?item.info:"";
              this.dialogData.icon=item.hasOwnProperty("type")?this.dialogIcon[item.type]:this.dialogIcon.info;
              if (item.hasOwnProperty("buttom"))this.dialogData.text=item.buttom;
              this.dialogVisible=true;
            },
        }
    };


</script>

<style lang="scss" >


    .el-dialog{
        display: flex;
        display: -ms-flex; /* 兼容IE */
        flex-direction: column;
        -ms-flex-direction: column; /* 兼容IE */
        margin:0 !important;
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        max-height:calc(100% - 30px);
        max-width:calc(100% - 30px);
    }
    .el-dialog .el-dialog__body{
        max-height: 100%;
        flex: 1;
        -ms-flex: 1 1 auto; /* 兼容IE */
        overflow-y: auto;
        overflow-x: hidden;
    }

    .el-dialog__wrapper {
        /*隐藏ie和edge中遮罩的滚动条*/
        overflow: hidden;
    }
    .dialogClass .el-dialog__footer {
        text-align: right;
    }
    // 修改弹框边框圆角
    /deep/.el-dialog.el-dialog--center {
        border-radius: 8px;
    }

    // 去掉弹框内容的默认padding值
    /deep/.el-dialog--center .el-dialog__body {
        padding: 0px;
        text-align: center;
    }
</style>
